<template>
  <div class="question" :class="{'test-constructor': isConstructor}">
    <div class="progress-bar"><div class="progress" ref="progress"/></div>

    <div class="question__top-actions mb-8">
      <div class="top-actions__item">
        <div v-if="testData.is_can_go_back" class="d-flex align-center text-gray pointer" @click="backStep">
          <img class="mr-3" src="@/assets/images/icons/arrow-gray.svg" alt="Назад">
          <span class="notranslate">Назад</span>
        </div>
      </div>
      <div class="top-actions__item text-center">
        <span class="notranslate">{{testData.question_number}} </span>
        <span class="text-gray notranslate">/ {{testData.questions_count}}</span>
      </div>
      <div class="top-actions__item">
        <div v-if="testData.timer" class="badge border-none badge-success ml-auto"
             :class="timer>10000?'badge-success':'badge-error'">
          {{$moment(timer).format('mm:ss')}}
        </div>
      </div>
    </div>
    <component v-bind:is="activeTest" :key="testData.question_number" :disabled="testData.is_feedback_available && feedBackText.length < 2">
      <template v-slot:feedback >
        <FeedbackTest v-if="testData.is_feedback_available"/>
      </template>
    </component>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { TEST_TYPES } from '@/common/constants/testTypes';
import { Q_TYPES } from '@/components/testEditor/QuestionTypes.js';
import MMPI from '@/components/tests/test-types/MMPI';
import NumericLogic from '@/components/tests/test-types/NumericLogic';
import VerbalLogic from '@/components/tests/test-types/VerbalLogic';
import NonVerbalLogic from '@/components/tests/test-types/NonVerbalLogic';
import ProfessionalInterests from '@/components/tests/test-types/ProfessionalInterests';

import QuestionRadio from '@/components/tests/test-types-constructor/QuestionRadio';
import QuestionCheckbox from '@/components/tests/test-types-constructor/QuestionCheckbox';
import QuestionList from '@/components/tests/test-types-constructor/QuestionList';
import QuestionText from '@/components/tests/test-types-constructor/QuestionText';
import QuestionTextarea from '@/components/tests/test-types-constructor/QuestionTextarea';
import QuestionNumber from '@/components/tests/test-types-constructor/QuestionNumber';
import TextMessage from '@/components/tests/test-types-constructor/TextMessage';
import TestUnknown from '@/components/tests/test-types-constructor/TestUnknown';
import QuestionRankedList from '@/components/tests/test-types-constructor/QuestionRankedList';
import QuestionPostiveNegative from '@/components/tests/test-types-constructor/QuestionPostiveNegative.vue';
import FeedbackTest from '@/components/tests/FeedbackTest.vue';

export default {
  name: 'Test',
  components: {
    FeedbackTest,
    MMPI,
    NumericLogic,
    VerbalLogic,
    NonVerbalLogic,
    ProfessionalInterests,
    TextMessage,
    TestUnknown,
    QuestionList,
    QuestionRadio,
    QuestionCheckbox,
    QuestionText,
    QuestionNumber,
    QuestionTextarea,
    QuestionRankedList,
    QuestionPostiveNegative,
  },
  data: () => ({
    timerId: null,
    timer: 0,
  }),
  computed: {
    ...mapGetters({
      testData: 'testing/testing/testData',
      isConstructor: 'testing/testing/isConstructor',
      feedBackText: 'testing/testing/feedBackText',
    }),
    activeTest() {
      switch (this.testData?.test_type) {
        case TEST_TYPES.MMPI: return 'MMPI';
        case TEST_TYPES.MINIMULT: return 'MMPI';
        case TEST_TYPES.NUMERIC_LOGIC: return 'NumericLogic';
        case TEST_TYPES.VERBAL_LOGIC: return 'VerbalLogic';
        case TEST_TYPES.NON_VERBAL_LOGIC: return 'NonVerbalLogic';
        case TEST_TYPES.PROF_INTERESTS: return 'ProfessionalInterests';
        default: {
          switch (this.testData?.question?.type) {
            case Q_TYPES.TEXT_MESSAGE: return 'TextMessage';
            case Q_TYPES.QUESTON_LIST: return 'QuestionList';
            case Q_TYPES.QUESTON_RADIO: return 'QuestionRadio';
            case Q_TYPES.QUESTON_CHECKBOX: return 'QuestionCheckbox';
            case Q_TYPES.QUESTON_NUMBER: return 'QuestionNumber';
            case Q_TYPES.QUESTON_TEXT: return 'QuestionText';
            case Q_TYPES.QUESTON_TEXTAREA: return 'QuestionTextarea';
            case Q_TYPES.QUESTON_RANKED: return 'QuestionRankedList';
            case Q_TYPES.QUESTON_POS_NEGATIVE: return 'QuestionPostiveNegative';
            default: return 'TestUnknown';
          }
        }
      }
    },
  },
  methods: {
    ...mapActions({
      backStep: 'testing/testing/backStep',
      nextStep: 'testing/testing/nextStep',
    }),
    updateProgress() {
      if (this.testData.questions_count && this.testData.question_number) {
        const numTotal = ((this.testData.question_number - 1) / this.testData.questions_count) * 100;
        this.$refs.progress.style.width = `${Math.floor(numTotal)}%`;
      }
    },
    countdownTimer(callback) {
      this.timer = this.testData.timer * 1000;
      clearInterval(this.timerId);
      this.timerId = setInterval(() => {
        this.timer -= 1000;
        if (this.timer < 1000) {
          this.timer = 0;
          clearInterval(this.timerId);
          this.timerId = null;
          callback();
        }
      }, 1000);
    },
  },
  watch: {
    // eslint-disable-next-line func-names
    '$store.state.testing.testing.testData.question_number': function () {
      this.updateProgress();
      if (this.testData.timer) {
        this.countdownTimer(this.nextStep);
      }
    },
  },

  mounted() {
    this.updateProgress();
    if (this.testData.timer) {
        this.countdownTimer(this.nextStep);
    }
  },
  beforeDestroy() {
    clearInterval(this.timerId);
  },
};
</script>
<style scoped lang="scss">
.progress-bar {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 0.5rem;
  background: #F5F4F4;
  & .progress {
    background: var(--v-primary-base);
    width: 0;
    height: 100%;
    transition: width 0.5s ease;
  }
}

.border-none {
  border: none;
}

</style>
